// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main_1tq2U","row":"index_row_S6Gr_"};